import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePrescriptionFragment = { readonly __typename?: 'SyncablePrescription', readonly id: string, readonly administrationApproach: Types.AdministrationApproach, readonly prescribableItemType: Types.PrescribableItemType, readonly prescribableItemFreeText?: string | null, readonly facilityId: string, readonly note?: string | null, readonly patientId: string, readonly prescribedByUserId: string, readonly startsAt: string, readonly stopsAt: string, readonly cancellationDetails?: { readonly __typename?: 'CancellationDetails', readonly at: string, readonly reason: string, readonly by?: { readonly __typename?: 'User', readonly _id: string } | null } | null, readonly clinicalEvent: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType }, readonly clinicalProduct?: { readonly __typename?: 'ClinicalProductRef', readonly id: string, readonly type: Types.ClinicalProductType } | null, readonly dosage: { readonly __typename?: 'DoseMeasurement', readonly value: number, readonly unit: string }, readonly frequency: { readonly __typename?: 'Frequency', readonly value: number, readonly unit: Types.TimeUnit }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string }, readonly minimumDoseInterval?: { readonly __typename?: 'MinimumDoseInterval', readonly value: number, readonly unit: Types.TimeUnit } | null, readonly rate?: { readonly __typename?: 'RateMeasurement', readonly value: number, readonly unit: Types.RateUnit } | null };

export type SyncPrescriptionPushMutationVariables = Types.Exact<{
  input: Types.PushPrescriptionInput;
}>;


export type SyncPrescriptionPushMutation = { readonly __typename?: 'Mutation', readonly pushPrescription: { readonly __typename?: 'PushPrescriptionResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncablePrescription', readonly id: string, readonly administrationApproach: Types.AdministrationApproach, readonly prescribableItemType: Types.PrescribableItemType, readonly prescribableItemFreeText?: string | null, readonly facilityId: string, readonly note?: string | null, readonly patientId: string, readonly prescribedByUserId: string, readonly startsAt: string, readonly stopsAt: string, readonly cancellationDetails?: { readonly __typename?: 'CancellationDetails', readonly at: string, readonly reason: string, readonly by?: { readonly __typename?: 'User', readonly _id: string } | null } | null, readonly clinicalEvent: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType }, readonly clinicalProduct?: { readonly __typename?: 'ClinicalProductRef', readonly id: string, readonly type: Types.ClinicalProductType } | null, readonly dosage: { readonly __typename?: 'DoseMeasurement', readonly value: number, readonly unit: string }, readonly frequency: { readonly __typename?: 'Frequency', readonly value: number, readonly unit: Types.TimeUnit }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string }, readonly minimumDoseInterval?: { readonly __typename?: 'MinimumDoseInterval', readonly value: number, readonly unit: Types.TimeUnit } | null, readonly rate?: { readonly __typename?: 'RateMeasurement', readonly value: number, readonly unit: Types.RateUnit } | null }> } };

export type SyncPrescriptionPullQueryVariables = Types.Exact<{
  input: Types.PullPrescriptionInput;
}>;


export type SyncPrescriptionPullQuery = { readonly __typename?: 'Query', readonly pullPrescription: { readonly __typename?: 'PullPrescriptionResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePrescription', readonly id: string, readonly administrationApproach: Types.AdministrationApproach, readonly prescribableItemType: Types.PrescribableItemType, readonly prescribableItemFreeText?: string | null, readonly facilityId: string, readonly note?: string | null, readonly patientId: string, readonly prescribedByUserId: string, readonly startsAt: string, readonly stopsAt: string, readonly cancellationDetails?: { readonly __typename?: 'CancellationDetails', readonly at: string, readonly reason: string, readonly by?: { readonly __typename?: 'User', readonly _id: string } | null } | null, readonly clinicalEvent: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType }, readonly clinicalProduct?: { readonly __typename?: 'ClinicalProductRef', readonly id: string, readonly type: Types.ClinicalProductType } | null, readonly dosage: { readonly __typename?: 'DoseMeasurement', readonly value: number, readonly unit: string }, readonly frequency: { readonly __typename?: 'Frequency', readonly value: number, readonly unit: Types.TimeUnit }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string }, readonly minimumDoseInterval?: { readonly __typename?: 'MinimumDoseInterval', readonly value: number, readonly unit: Types.TimeUnit } | null, readonly rate?: { readonly __typename?: 'RateMeasurement', readonly value: number, readonly unit: Types.RateUnit } | null }> } };

export const WholeSyncablePrescriptionFragmentDoc = gql`
    fragment WholeSyncablePrescription on SyncablePrescription {
  id
  administrationApproach
  cancellationDetails {
    at
    by {
      _id
    }
    reason
  }
  clinicalEvent {
    id
    type
  }
  prescribableItemType
  clinicalProduct {
    id
    type
  }
  prescribableItemFreeText
  dosage {
    value
    unit
  }
  facilityId
  frequency {
    value
    unit
  }
  meta {
    createdAt
    createdByUserId
    deleted
    updatedAt
    updatedByUserId
  }
  minimumDoseInterval {
    value
    unit
  }
  note
  patientId
  prescribedByUserId
  rate {
    value
    unit
  }
  startsAt
  stopsAt
}
    `;
export const SyncPrescriptionPushDocument = gql`
    mutation SyncPrescriptionPush($input: PushPrescriptionInput!) {
  pushPrescription(input: $input) {
    rows {
      ...WholeSyncablePrescription
    }
  }
}
    ${WholeSyncablePrescriptionFragmentDoc}`;
export type SyncPrescriptionPushMutationFn = Apollo.MutationFunction<SyncPrescriptionPushMutation, SyncPrescriptionPushMutationVariables>;

/**
 * __useSyncPrescriptionPushMutation__
 *
 * To run a mutation, you first call `useSyncPrescriptionPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPrescriptionPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPrescriptionPushMutation, { data, loading, error }] = useSyncPrescriptionPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPrescriptionPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncPrescriptionPushMutation, SyncPrescriptionPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPrescriptionPushMutation, SyncPrescriptionPushMutationVariables>(SyncPrescriptionPushDocument, options);
      }
export type SyncPrescriptionPushMutationHookResult = ReturnType<typeof useSyncPrescriptionPushMutation>;
export type SyncPrescriptionPushMutationResult = Apollo.MutationResult<SyncPrescriptionPushMutation>;
export type SyncPrescriptionPushMutationOptions = Apollo.BaseMutationOptions<SyncPrescriptionPushMutation, SyncPrescriptionPushMutationVariables>;
export const SyncPrescriptionPullDocument = gql`
    query SyncPrescriptionPull($input: PullPrescriptionInput!) {
  pullPrescription(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePrescription
    }
  }
}
    ${WholeSyncablePrescriptionFragmentDoc}`;

/**
 * __useSyncPrescriptionPullQuery__
 *
 * To run a query within a React component, call `useSyncPrescriptionPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPrescriptionPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPrescriptionPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPrescriptionPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPrescriptionPullQuery, SyncPrescriptionPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPrescriptionPullQuery, SyncPrescriptionPullQueryVariables>(SyncPrescriptionPullDocument, options);
      }
export function useSyncPrescriptionPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPrescriptionPullQuery, SyncPrescriptionPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPrescriptionPullQuery, SyncPrescriptionPullQueryVariables>(SyncPrescriptionPullDocument, options);
        }
export type SyncPrescriptionPullQueryHookResult = ReturnType<typeof useSyncPrescriptionPullQuery>;
export type SyncPrescriptionPullLazyQueryHookResult = ReturnType<typeof useSyncPrescriptionPullLazyQuery>;
export type SyncPrescriptionPullQueryResult = Apollo.QueryResult<SyncPrescriptionPullQuery, SyncPrescriptionPullQueryVariables>;